import { tranfer_bank_to_hotel } from "@/constants/hotels";
import { BANK_IMG, BANK_TYPE2 } from "@/constants/programs";

export function getBanksByHotelName(name: string) {
  const banks = [];
  for (const [key, value] of tranfer_bank_to_hotel.entries()) {
    if (value.includes(name)) {
      const bname = BANK_TYPE2.get(key);
      if (bname && BANK_IMG[bname]) {
        banks.push({ img: BANK_IMG[bname], name: bname });
      }
    }
  }

  return banks;
}


export function getBanksByHotelNameSmall(name: string) {
  const banks = [];
  for (const [key, value] of tranfer_bank_to_hotel.entries()) {
    if (value.includes(name)) {
      const bname = BANK_TYPE2.get(key);
      if (bname && BANK_IMG[bname]) {
        banks.push({ img: BANK_IMG[bname], name: bname });
      }
    }
  }

  return banks;
}
